module.exports = {"TXTCLI_Probability_1M":{"id":"TXTCLI_Probability_1M","defaultMessage":"Kans/1M","track":"Probability/1M"}}